export class OrderCreateRequestBuilder {
    constructor() {
        this.properties = {};
    }
    static validateRequest(request) {
        if (!request) {
            throw new Error("Missing order creation request");
        }
        if (!request.id) {
            throw new Error("Missing vehicle ID in order creation request");
        }
        if (!request.customer) {
            throw new Error("Missing customer in order creation request");
        }
        if (!request.payment) {
            throw new Error("Missing payment in order creation request");
        }
        if (!request.deliveryType) {
            throw new Error("Missing delivery type in order creation request");
        }
    }
    forVehicle(id) {
        this.properties.id = id;
        return this;
    }
    withAccessories(accessories) {
        this.properties.accessories = accessories.map((a) => {
            return { id: a.id };
        });
        return this;
    }
    withCustomer(customer) {
        this.properties.customer = customer;
        return this;
    }
    withPayment(payment) {
        this.properties.payment = payment;
        return this;
    }
    withDeliveryType(deliveryType) {
        this.properties.deliveryType = deliveryType;
        return this;
    }
    withInsurance(insurance) {
        this.properties.insurance = insurance;
        return this;
    }
    withTradeIn(tradein) {
        this.properties.tradein = tradein;
        return this;
    }
    withUrls(redirect, payment) {
        this.properties.urls = { redirect, payment };
        return this;
    }
    build() {
        return this.properties;
    }
}
